import '@accessible360/accessible-slick';
import './navigation';
import './products';

(function ($) {

	$('.indy-block-tabs .nav-link').on("click", function () {
		let id = $(this).data('id');
		$(".nav-link, .tab-pane").removeClass('active');
		$(this).add(".tab-pane[data-id='" + id + "']").addClass('active');
	})

	/**
	 * Toggle accordions
	 */
	$('.indy-block-accordion__collapsed').on("click", function () {
		$(this).parent().toggleClass('is-active');
	});


	/**
	 * Sliders
	 */
	$('#pageSlider').slick({
		mobileFirst: true,
		infinite: true,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		slidesToShow: 1,
		prevArrow: $('.page-slider-btn.left'),
		nextArrow: $('.page-slider-btn.right'),
		centerMode: false,
		swipeToSlide: false,
		fade: true,
		speed: 200
	});

	let prevArrow = $('.indy-block-hero-slider-btn.left');
	let nextArrow = $('.indy-block-hero-slider-btn.right');
	$('#heroSlider').slick({
		mobileFirst: true,
		infinite: false,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		slidesToShow: 1,
		prevArrow: prevArrow,
		nextArrow: nextArrow,
		centerMode: false,
		swipeToSlide: false,
		fade: true,
		speed: 200
	});

	$('.indy-block-shop-teaser').each(function () {
		let slider = $(this).find($('.indy-block-shop-teaser-inner'));
		let prevArrow = $(this).find($('.indy-block-shop-teaser-btn.left'));
		let nextArrow = $(this).find($('.indy-block-shop-teaser-btn.right'));
		slider.slick({
			mobileFirst: true,
			infinite: false,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			slidesToShow: 1,
			prevArrow: prevArrow,
			nextArrow: nextArrow,
			centerMode: false,
			swipeToSlide: true,
			speed: 200,
			responsive: [
				{
					breakpoint: 1, // 1px-576px wide screen for smaller centerPadding
					settings: {
						centerPadding: '4rem',
					}
				},
				{
					breakpoint: 576,
					settings: {
						centerPadding: '6rem',
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1400,
					settings: {
						centerMode: false,
						slidesToShow: 5,
					}
				},
			]
		});
	});

	$('.indy-block-categories').each(function () {
		let slider = $(this).find($('.indy-block-categories-inner'));
		let prevArrow = $(this).find($('.indy-block-categories-btn.left'));
		let nextArrow = $(this).find($('.indy-block-categories-btn.right'));

		const headerImages = [...$(this).find(".category-slide .image")];
		const promsImages = headerImages.map(image => new Promise((res, rej) => {

			if (image.complete) {
				res();
			} else {
				image.onload = () => {
					image.onload = res();
				};
			}
		}));

		// Wait for all images to load before initializing the slider
		Promise.all(promsImages)
			.then(() => {
				slider.slick({
					mobileFirst: true,
					infinite: false,
					slidesToScroll: 1,
					dots: false,
					arrows: true,
					slidesToShow: 1,
					prevArrow: prevArrow,
					nextArrow: nextArrow,
					centerMode: false,
					swipeToSlide: true,
					speed: 200,
					responsive: [
						{
							breakpoint: 1, // 1px-576px wide screen for smaller centerPadding
							settings: {
								centerPadding: '4rem',
								slidesToShow: 1
							}
						},
						{
							breakpoint: 576,
							settings: {
								centerPadding: '6rem',
								slidesToShow: 1
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 3
							}
						},
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 4
							}
						},
						{
							breakpoint: 1400,
							settings: {
								centerMode: false,
								slidesToShow: 5
							}
						},
					]
				});
			})
	});

	/**
	 * SVG Animation
	 */

	setTimeout(function () {
		$('.animation').removeClass('in-progress');
	}, 6250); // animation duration (set in css)

	$('.animation').hover(function () {
		let circles = $('.cls-2');
		let colors = ['red', 'grey'];

		let randColors = [Math.trunc(Math.random() * 2), Math.trunc(Math.random() * 2), Math.trunc(Math.random() * 2)];
		let randCircles = [Math.trunc(Math.random() * 24) + 1, Math.trunc(Math.random() * 24) + 1, Math.trunc(Math.random() * 24) + 1];

		if (randColors.every((val, i, arr) => val === arr[0])) {
			if (randColors[0] == 1) {
				randColors[0] = 0;
			} else {
				randColors[0] = 1;
			}
		}

		for (let i = 0; i < randCircles.length; i++) {
			$(circles[randCircles[i]]).addClass('active').addClass(colors[randColors[i]])
		}

	}, function () {
		$('.cls-2').removeClass('active grey red')
	})

	$('.indy-block-testimonial-slider').each(function () {
		let slider = $(this).find('.testimonial-slider');
		let prevArrow = $(this).find('.testimonial-slider-btn.left');
		let nextArrow = $(this).find('.testimonial-slider-btn.right');

		let slideCount = slider.find('.testimonial-slide').length;

		if (slideCount <= 1) {
			prevArrow.hide();
			nextArrow.hide();
			return;
		}

		slider.slick({
			mobileFirst: true,
			infinite: true,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			slidesToShow: 1,
			prevArrow: prevArrow,
			nextArrow: nextArrow,
			fade: true,
			speed: 300,
			adaptiveHeight: false
		});
	});

})(jQuery);
